module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=pattern>*The phone number must be valid </span> ";